import WelcomeFooter from "./WelcomeFooter";
import TitleContainer from "./TitleContainer";
import VideoContainer from "./VideoContainer";
import LoginForm from "./LoginForm";
//import gif from './images/testgif.gif';
import WelcomeVideo from "./WelcomeVideo";
import A from "./ActionCreators";
import SigninModal from "./SigninModal";
import { useDispatch, useSelector } from "react-redux";
import { useState, useRef } from "react";
import useElementDims from "./useElementDims";

const border = false;

export default function WelcomeScene({ setMode, setAuthModal, mobile }) {
  let dispatch = useDispatch();
  const [loginContainer, setLoginContainer] = useState(null);
  let dims = useElementDims({ state: loginContainer });

  let layout;
  if (!mobile) {
    layout = (
      <div
        class="rel sg-row"
        style={{
          marginLeft: "5%",
          marginRight: "5%",
          outline: border && "1px solid blue",
        }}
        class="full-width"
      >
        <div
          class="sg-row rel fair-margin-bottom"
          style={{
            marginTop: "2.5%",
            //border:border && '3px solid lime',
            //textAlign:'center',
            marginBottom:'5%',
          }}
        >
          <TitleContainer mobile={mobile} />
          <div
            style={{
              position: "absolute",
              height: "100%",
              width: 30,
              border: border && "3px solid orange",
              right: 0,
            }}
          ></div>
        </div>

        <div
          style={{
            //outline:border && '1px solid blue',
            //borderRight:'1px solid #aaa',
            border: border && "3px solid green",
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center'
          }}
          class="sg-row rel"
        >
          <div
            style={{
              //border:'3px solid orange',
              marginRight: "5%",
            }}
          >
            <VideoContainer mobile={mobile} 
              height={dims && dims.height - 20} 
            />
          </div>

          <div
            class="full-height sg-col"
            style={{
              minWidth: "30%",
              border: border && "3px solid purple",

              //textAlign:'center',
            }}
          >
            <LoginForm {...{ mobile, setMode, loginContainerRef: el => setLoginContainer(el) }} />
          </div>
        </div>

        <div
          style={{
            marginTop: 50,
            width: "100%",
            height: 1,
            background: "#d0d0d0",
          }}
        />
      </div>
    );
    //let componentOrder = [ videoHalf, authHalf ];
  } else {
    layout = (
      <div class="sg-col full-width">
        <TitleContainer mobile={mobile} />
        <div style={{margin:'5%'}} />
        <LoginForm {...{ mobile, setMode, loginContainerRef: el => setLoginContainer(el) }} />
        <div
          style={{
            margin: "5%",
          }}
        >
          <VideoContainer mobile={mobile} height="100%" />
        </div>
      </div>
    );
  }

  let flexDirection = mobile ? "sg-col" : "sg-row";

  return (
    <div
      style={
        {
          //background:'#f0f0f0',
        }
      }
      class={`full-width flex-expand rel `}
    >
      <div
        style={{
          width: "100%",
        }}
        class={flexDirection}
      >
        {layout}
      </div>
      <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
        {/* <img src="./images/LF-logo.png" style={{ 
          height: 40,
          //position: 'absolute',
          //top: 5,
          //left: 15
        }} />  */}
      </div>

      <WelcomeFooter/>

      

    </div>
  );
}
